export const SET_PROJECT_STATE = 'SET_PROJECT_STATE';
export const SET_PROJECT_NAME = 'SET_PROJECT_NAME';
export const SET_PROJECT_STREET = 'SET_PROJECT_STREET';
export const SET_PROJECT_STREET_2 = 'SET_PROJECT_STREET_2';
export const SET_PROJECT_ZIP = 'SET_PROJECT_ZIP';
export const SET_PROJECT_COUNTRY = 'SET_PROJECT_COUNTRY';
export const SET_PROJECT_CITY = 'SET_PROJECT_CITY';
export const SET_PROJECT_ADDRESS = 'SET_PROJECT_ADDRESS';



// WEBPACK FOOTER //
// ./src/containers/common/projectaddress/constants.js